
$(document).ready(function () {
	$('.sidebarCollapse').on('click', function () {
		$('#sidebar').toggleClass('active');
		$('.sidebarCollapse.d-xl-none').toggleClass('d-xl-block');
	});
});
